export const endpoints = {
  auth: {
    signIn: "/user-management/auth/login",
    signUp: "/user-management/users/save",
    userById: (userId) => `/user-management/users/${userId}`,
  },
  admin: {
    products: {
      all: "/product-service/product/all-products",
      list: "/product-service/product/list-products",
      create: "/product-service/product/create-product",
      update: (productId) => `/product-service/product/update-product/${productId}`,
      uploadImage: "/product-service/product/upload",
    },
    categories: {
      all: "/product-service/category/get-all-categories-without-pagination",
      byId: (categoryId) => `/product-service/category/get-category/${categoryId}`,
      save: "/product-service/category/save-or-update-category",
    },
    brands: {
      all: "/product-service/brand/get-all-brands-without-pagination",
      byId: (brandId) => `/product-service/brand/get-brand/${brandId}`,
      save: "/product-service/brand/save-or-update-brand",
    },
    catalogImport: {
      upload: "/product-service/catalog-import/upload",
      previewAlias: "/product-service/catalog-import/preview",
      batches: "/product-service/catalog-import/batches",
      preview: (batchId) => `/product-service/catalog-import/batches/${batchId}/preview`,
      confirm: "/product-service/catalog-import/confirm",
      template: "/product-service/catalog-import/template",
    },
    orders: {
      search: "/order-management-service/orders/admin/search-orders",
      details: (orderId) => `/order-management-service/orders/admin/${orderId}`,
      updateStatus: (orderId) => `/order-management-service/orders/admin/${orderId}/status`,
      cancel: (orderId) => `/order-management-service/orders/admin/${orderId}/cancel`,
      refund: (orderId) => `/order-management-service/orders/admin/${orderId}/refunds`,
      substitutes: (orderId, orderItemId) =>
        `/order-management-service/orders/admin/${orderId}/items/${orderItemId}/substitutes`,
      substitute: (orderId, orderItemId) =>
        `/order-management-service/orders/admin/${orderId}/items/${orderItemId}/substitute`,
      unavailable: (orderId, orderItemId) =>
        `/order-management-service/orders/admin/${orderId}/items/${orderItemId}/unavailable`,
    },
    checkoutSettings: {
      current: "/order-management-service/checkout-settings/current",
      serviceablePincodes: "/order-management-service/checkout-settings/serviceable-pincodes",
      serviceablePincodeStatus: (id) =>
        `/order-management-service/checkout-settings/serviceable-pincodes/${id}/status`,
      serviceabilityDemands:
        "/order-management-service/checkout-settings/serviceable-pincodes/demands",
      getDeliverySlots: (activeOnly = false) =>
        `/order-management-service/checkout-settings/get-delivery-slots${activeOnly ? "?activeOnly=true" : ""}`,
      createDeliverySlot:
        "/order-management-service/checkout-settings/create-delivery-slot",
      updateDeliverySlots:
        "/order-management-service/checkout-settings/update-delivery-slots",
      updateDeliverySlot: (id) =>
        `/order-management-service/checkout-settings/update-delivery-slot/${id}`,
      updateDeliverySlotStatus: (id) =>
        `/order-management-service/checkout-settings/update-delivery-slot-status/${id}`,
      deleteDeliverySlot: (id) =>
        `/order-management-service/checkout-settings/delete-delivery-slot/${id}`,
      updateDeliverySlotInactive: (id) =>
        `/order-management-service/checkout-settings/update-delivery-slot-inactive/${id}`,
      resetDefaultDeliverySlots:
        "/order-management-service/checkout-settings/reset-default-delivery-slots",
      deliverySlots: (activeOnly = false) =>
        `/order-management-service/checkout-settings/get-delivery-slots${activeOnly ? "?activeOnly=true" : ""}`,
      deliverySlotStatus: (id) =>
        `/order-management-service/checkout-settings/update-delivery-slot-status/${id}`,
      deliverySlotDelete: (id) =>
        `/order-management-service/checkout-settings/delete-delivery-slot/${id}`,
      deliverySlotsResetDefaults:
        "/order-management-service/checkout-settings/reset-default-delivery-slots",
    },
    workflows: {
      statusTypes: {
        all: "/order-management-service/status-types/status-type-all",
        create: "/order-management-service/status-types/create-status-type",
        update: (statusTypeId) =>
          `/order-management-service/status-types/update-status-type/${statusTypeId}`,
        byId: (statusTypeId) =>
          `/order-management-service/status-types/get-status-type/${statusTypeId}`,
      },
      workflows: {
        all: "/order-management-service/workflows/workflow/get-all",
        create: "/order-management-service/workflows/create-workflow",
        update: (workflowId) =>
          `/order-management-service/workflows/update-workflow/${workflowId}`,
        byId: (workflowId) =>
          `/order-management-service/workflows/get-by-id/${workflowId}`,
      },
      statuses: {
        all: "/order-management-service/workflows/statuses/get-all",
        create: "/order-management-service/workflows/statuses/create",
        update: (statusId) =>
          `/order-management-service/workflows/statuses/update/${statusId}`,
        byId: (statusId) =>
          `/order-management-service/workflows/statuses/get-by-id/${statusId}`,
      },
      states: {
        all: (workflowId) =>
          `/order-management-service/workflows/${workflowId}/states/get-all`,
        create: (workflowId) =>
          `/order-management-service/workflows/${workflowId}/states/create`,
        update: (stateId) =>
          `/order-management-service/workflows/states/update/${stateId}`,
        byId: (stateId) =>
          `/order-management-service/workflows/states/get-by-id/${stateId}`,
      },
      transitions: {
        all: (workflowId) =>
          `/order-management-service/workflows/${workflowId}/transitions/get-all`,
        create: (workflowId) =>
          `/order-management-service/workflows/${workflowId}/transitions/create`,
        update: (transitionId) =>
          `/order-management-service/workflows/transitions/update/${transitionId}`,
        byId: (transitionId) =>
          `/order-management-service/workflows/transitions/get-by-id/${transitionId}`,
      },
    },
    customers: {
      search: "/user-management/admin/customers/search",
      byId: (customerId) => `/user-management/admin/customers/${customerId}`,
    },
    users: {
      all: "/user-management/admin/users",
    },
  },
};
